export function variantBrand(varant, vue) {
  if (vue?.$route?.params?.brand) {
    return vue.$route.params.brand + "-" + varant;
  }
  return varant;
}
